import { connect } from 'react-redux';
import { push } from 'react-router-redux/lib/actions';
import { ROUTE_FAN_BOX_MESSAGE_ROOT } from './../constants';
import fanBoxMessagesAction from '../../../actions/fanboxMessages';
import FanBoxMessageNew from './FanBoxMessageNew';

export default connect(
  (state) => ({
    title: 'Create Message',
    loading: state.fanBoxMessages.loadingItem,
    model: state.fanBoxMessages.model,
    initialValues: state.fanBoxMessages.model
  }),
  dispatch => ({
    fetch: () => dispatch(fanBoxMessagesAction.createModel()),
    save: (item, data) => dispatch(fanBoxMessagesAction.save(item, data)),
    goIndex: () => dispatch(push(ROUTE_FAN_BOX_MESSAGE_ROOT))
  })
)(FanBoxMessageNew)



// WEBPACK FOOTER //
// ./src/components/FanBox/FanBoxMessageNew/index.js